import { makeStyles } from "@fluentui/react-components";
import designTokens from "theme/customTheme";

export const useManageTagsStyles = makeStyles({
  nameTextExtra: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  truncatedText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});
